import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import OnePageLayout from "../../components/layout/OnePageLayout";
import {
  Btns,
  ButtonL,
  ButtonM,
  Content,
  FlexBox,
  ImgWrap,
  InputsDiv,
  Section,
  TextDiv,
} from "../../styles/Common";
import { styled } from "styled-components";
import holdImg from "../../styles/images/img_hold.png";
import { userActions } from "../../store/slices/userSlice";
import EditMyInfo from "../../components/myPage/EditMyInfo";
import { getToken } from "../../components/hooks/authFunc";
import useDidMountEffect from "../../components/hooks/useDidMountEffect";
import { Modal } from "../../components/modal/Modal";
import OnlyHeaderLayout from "../../components/layout/OnlyHeaderLayout";

const CheckPw = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [password, setPassword] = useState("");
  const [openModal, setOpenModal] = useState(false);

  const isPwChecking = useSelector((state) => state.user.checkPasswordSuccess);
  const changeUserNameSuccess = useSelector(
    (state) => state.user.changeUserNameSuccess
  );
  const changeUserPhoneSuccess = useSelector(
    (state) => state.user.changeUserPhoneSuccess
  );
  const modalMsg = useSelector((state) => state.user.modalMsg);
  const accessToken = getToken();
  const result = location.state !== null ? location.state.result : "";
  const callbackParams = location.state !== null ? location.state.params : {};

  const validatePage = JSON.parse(sessionStorage.getItem("page")) || "";

  useEffect(() => {
    // console.log("password check", result, callbackParams, validatePage.option);
    //본인인증 이후의 페이지, 비밀번호 변경페이지가 해당됨
    if (result && callbackParams) {
      dispatch(userActions.fetchInitCheckPassword(true));
      if (validatePage.option == "name") {
        const params = {
          name: callbackParams.name,
          tid: callbackParams.tid,
        };
        // console.log("이름 변경 api 연동", params, accessToken);
        dispatch(userActions.fetchChangeUserName({ params, accessToken }));
      } else if (validatePage.option == "phone") {
        const params = {
          phone: callbackParams.phone,
          tid: callbackParams.tid,
        };
        // console.log("폰번호 변경 api 연동", params, accessToken);
        dispatch(userActions.fetchChangeUserPhone({ params, accessToken }));
      } else if (validatePage.option == "email") {
        const params = {};
        dispatch(userActions.fetchUserLookup({ params, accessToken }));
      }
    } else {
      sessionStorage.removeItem("page");
      //들어올때마다 isPwChecking 값을 reset 해서 비밀번호 입력 화면이 우선 노출
      dispatch(userActions.fetchInitCheckPassword(false));
    }
  }, []);

  const handleCheckPassword = () => {
    const params = {
      password: password,
    };
    dispatch(userActions.fetchCheckPassword({ params, accessToken }));
  };
  useDidMountEffect(() => {
    if (modalMsg.msg) {
      setOpenModal(true);
    }
  }, [modalMsg]);
  return (
    <OnlyHeaderLayout title="회원정보">
      {openModal && (
        <Modal
          setOpenModal={setOpenModal}
          callbackFunc={
            changeUserNameSuccess == true || changeUserPhoneSuccess == true
              ? () => {
                  //todo : 폰번호변경, 이름 변경 성공 시, callback으로 userInfo 값 새로 받아오기
                  const params = {};
                  dispatch(
                    userActions.fetchUserLookup({ params, accessToken })
                  );
                }
              : () => {
                  setPassword("");
                }
          }
        >
          <p>{modalMsg.type === "func" ? modalMsg.msg() : modalMsg.msg}</p>
        </Modal>
      )}
      {isPwChecking ? (
        <EditMyInfo />
      ) : (
        <Section className="minPaddingTop">
          <Content>
            <TextDiv>
              <h3>
                회원님의 개인정보보호를 위해
                <br />
                로그인 시 사용하는 비밀번호를 입력해주세요.
              </h3>
            </TextDiv>
            <PwInputDiv>
              <div>
                <input
                  type="password"
                  placeholder="비밀번호를 입력하세요."
                  name="password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                />
              </div>
            </PwInputDiv>
            <ImgWrap imgwidth="9.76" margintop="12.9">
              <img src={holdImg} alt="" />
            </ImgWrap>
          </Content>
          <Btns>
            <ButtonL
              onClick={() => {
                handleCheckPassword();
              }}
            >
              확인
            </ButtonL>
          </Btns>
        </Section>
      )}
    </OnlyHeaderLayout>
  );
};

export default CheckPw;
const PwInputDiv = styled(InputsDiv)`
  margin-top: 5rem;
`;
